import { p2 } from '../dates.js';
import { t } from '../i18n/index.js';
import { materialize, meetOf, stuName } from '../model.js';
import { S } from '../state.js';
import { $, ask, esc, toast } from '../ui.js';
import { completeFlow } from './calendar.js';

export let TIMER=null;
export function startTimer(evt){
  if(TIMER){toast(t('timer.running'));return}
  const ses=materialize(evt);
  if(meetOf(ses))window.open(meetOf(ses),'_blank');
  TIMER={sesId:ses.id,start:Date.now(),plan:Math.max(1,(ses.dur||60)*60)};
  buildTimerPill(ses);
  TIMER.int=setInterval(tickTimer,1000);
  toast(t('timer.started'));
}
export function buildTimerPill(ses){
  $('#timerroot').innerHTML=`<div class="timerpill">
    <span class="pulse"></span>
    <div class="tmid">
      <div class="tt" id="tm-el">00:00</div>
      <div class="tn">${esc(stuName(ses.studentId))} · ${ses.dur} ${t('c.min')}</div>
      <div class="tprog"><i id="tm-bar"></i></div>
    </div>
    <button class="tstop" id="timerstop"><svg viewBox="0 0 24 24"><rect x="7" y="7" width="10" height="10" rx="2" fill="currentColor" stroke="none"/></svg>${t('timer.stop')}</button>
    <button class="tx" id="timerx" title="${esc(t('c.cancel'))}"><svg viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18"/></svg></button>
  </div>`;
  $('#timerstop').onclick=stopTimer;
  $('#timerx').onclick=discardTimer;
  tickTimer();
}
export function tickTimer(){
  if(!TIMER)return;
  const elN=$('#tm-el'),bar=$('#tm-bar');
  if(!elN||!bar)return;
  const el=Math.floor((Date.now()-TIMER.start)/1000);
  elN.textContent=p2(Math.floor(el/60))+':'+p2(el%60);
  const pct=Math.min(100,el/TIMER.plan*100);
  bar.style.width=pct+'%';
  if(el>=TIMER.plan)bar.style.background='var(--marge)';
}
export function stopTimer(){
  if(!TIMER)return;
  const el=Math.floor((Date.now()-TIMER.start)/1000);
  const ses=S.sessions.find(x=>x.id===TIMER.sesId);
  const mins=Math.max(5,Math.round(el/60/5)*5);
  clearInterval(TIMER.int);TIMER=null;$('#timerroot').innerHTML='';
  if(ses)completeFlow(ses,mins);
}
export function discardTimer(){
  ask(t('timer.discard'),()=>{
    if(!TIMER)return;
    clearInterval(TIMER.int);TIMER=null;$('#timerroot').innerHTML='';
  },true);
}

/* ================= STUDENT MESSENGER ================= */
